/**
 * Acceso de prueba, SOLO en localhost / builds dev. Espejo de los defaults de
 * `backend/app/config.py` (`TEST_CLUB_NAME`, `TEST_KIT_CODE`, `TEST_PLAYER_*`), igual que
 * `vr-app/src/dev/devTestAccess.ts`. Si cambian alla, cambian aca.
 *
 * OJO (mg, 2026-09-09): el backend YA NO los siembra en el arranque — el seed
 * salio de `app/main.py` porque se re-creaba tambien en produccion. Estas
 * credenciales sirven despues de correr el seed a mano:
 *
 *     docker compose exec backend uv run python -m scripts.seed_demo_world
 *
 * Sin eso, el codigo y el PIN de aca no existen en la base.
 */
export const DEV_TEST_ACCESS = {
  clubName: 'Testarudos',
  kitCode: 'PRUEBA86',
  playerDisplayName: 'Jugador de prueba',
  playerUsername: 'jugador-prueba',
  playerPin: '123456',
  playerPassword: 'prueba123',
} as const

export function isLocalDev(): boolean {
  return import.meta.env.DEV || window.location.hostname === 'localhost'
}
